export enum AuditTrailType {
    Announcements,
    GeneralDocuments,
    SiteCommunications,
    SiteActions,
    SponsorCommunications,
    StudyDocuments
}